import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://v-room.app/api';

export default function ReferralTab({ token }) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied,  setCopied]  = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`${API}/referral/my-code`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(await res.json());
    } catch {}
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const copyLink = () => {
    navigator.clipboard.writeText(data.link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  if (loading) return (
    <div className="tab-loading"><div className="profile-spinner"></div></div>
  );

  return (
    <div className="referral-tab">

      {/* NAGŁÓWEK */}
      <div className="referral-hero">
        <span className="material-icons referral-hero-icon">group_add</span>
        <h2 className="referral-hero-title">ZAPROŚ ZNAJOMYCH</h2>
        <p className="referral-hero-sub">
          Za każdą rejestrację przez Twój link otrzymujesz <strong>+50 pkt</strong>.<br />
          Nowy użytkownik dostaje <strong>+10 pkt</strong> na start!
        </p>
      </div>

      {/* KOD + LINK */}
      <div className="referral-code-card">
        <div className="referral-code-label">TWÓJ KOD REFERRALOWY</div>
        <div className="referral-code-value">{data?.code ?? '...'}</div>

        <div className="referral-link-row">
          <span className="referral-link-text">{data?.link}</span>
          <button className={`btn-copy ${copied ? 'copied' : ''}`} onClick={copyLink}>
            <span className="material-icons">{copied ? 'check' : 'content_copy'}</span>
            {copied ? 'SKOPIOWANO!' : 'KOPIUJ'}
          </button>
        </div>

        <div className="referral-share-btns">
          <a
            href={`https://wa.me/?text=${encodeURIComponent(`Dołącz do VROOM! 🚗 Aplikacja dla kierowców – rejestruj się przez mój link i dostaniesz punkty na start: ${data?.link}`)}`}
            target="_blank" rel="noreferrer"
            className="btn-share btn-whatsapp"
          >
            <span className="material-icons">chat</span> WhatsApp
          </a>
          <a
            href={`https://t.me/share/url?url=${encodeURIComponent(data?.link ?? '')}&text=${encodeURIComponent('Dołącz do VROOM! 🚗')}`}
            target="_blank" rel="noreferrer"
            className="btn-share btn-telegram"
          >
            <span className="material-icons">send</span> Telegram
          </a>
        </div>
      </div>

      {/* STATYSTYKI */}
      <div className="referral-stats-row">
        <div className="referral-stat">
          <div className="referral-stat-value">{data?.usedCount ?? 0}</div>
          <div className="referral-stat-label">ZAPROSZONYCH</div>
        </div>
        <div className="referral-stat">
          <div className="referral-stat-value">{data?.pointsEarned ?? 0}</div>
          <div className="referral-stat-label">ZDOBYTYCH PKT</div>
        </div>
      </div>

      {/* LISTA ZAPROSZONYCH */}
      {data?.referrals?.length > 0 && (
        <div className="referral-list">
          <div className="referral-list-title">ZAPROSZENI UŻYTKOWNICY</div>
          {data.referrals.map(u => (
            <div key={u.id} className="referral-list-item">
              <div className="referral-list-avatar">
                {u.avatarUrl
                  ? <img src={u.avatarUrl} alt={u.username} />
                  : <span>{u.username?.slice(0, 2).toUpperCase()}</span>
                }
              </div>
              <div className="referral-list-info">
                <div className="referral-list-name">{u.username}</div>
                <div className="referral-list-date">
                  Dołączył: {new Date(u.createdAt).toLocaleDateString('pl-PL')}
                </div>
              </div>
              <div className="referral-list-pts">+50 pkt</div>
            </div>
          ))}
        </div>
      )}

      {data?.referrals?.length === 0 && (
        <div className="profile-empty" style={{ marginTop: 20 }}>
          <span className="material-icons">person_add</span>
          <p>Jeszcze nikogo nie zaprosiłeś</p>
          <span>Udostępnij link znajomym!</span>
        </div>
      )}

    </div>
  );
}